import React from "react";
import { motion } from "framer-motion";
import { Success, Warning } from "../../Assets/Icons";
import styles from "./toast.module.scss"; 

interface CustomToastProps {
  closeToast: () => void;
  type: "success" | "error";
  children: React.ReactNode;
}

const CustomToast: React.FC<CustomToastProps> = ({ closeToast, type, children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className={`${styles.toast} ${styles[type]}`}
    >
      <div className={styles.icon}>
        <img src={type === 'success' ? Success : Warning} alt='icon.svg' />
      </div>
      <div className={styles.message}>{children}</div>
      <button className={styles.closeBtn} onClick={closeToast}>✖</button>
    </motion.div>
  );
};

export default CustomToast;
